export interface Company {
  cust_no: string;
  cust_name: string;
}

export interface TokenResponse {
  token: string;
  refreshToken: string;
  expirationTime: string;
}

const API_BASE_URL = 'https://trpliveapi1.tripbox.co.kr';

// 회사 목록 조회
export async function fetchCompanyList(username: string, password: string): Promise<Company[]> {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Token/Token_ERP_CUST_LIST2?userName=${encodeURIComponent(username)}&userPw=${encodeURIComponent(password)}`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch company list');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching company list:', error);
    throw error;
  }
}

// 토큰 발급
export const fetchToken = async (email: string, password: string, company: string, userPath: string): Promise<TokenResponse> => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Token/Token_ERP2?userName=${encodeURIComponent(email)}&userPassword=${encodeURIComponent(password)}&custNo=${encodeURIComponent(company)}&userPath=${encodeURIComponent(userPath)}`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch token');
    }

    const data = await response.json();
    const expirationTime = new Date().getTime() + (24 * 60 * 60 * 1000); // 24시간

    return {
      token: data.token || data.Token,
      refreshToken: data.refreshToken || data.RefreshToken,
      expirationTime: expirationTime.toString()
    };
  } catch (error) {
    console.error('Token fetch error:', error);
    throw error;
  }
};

export const isAuthenticated = () => {
  try {
    const token = localStorage.getItem('token');
    const expirationTime = localStorage.getItem('expirationTime');
    
    if (!token || !expirationTime) {
      console.log('No token or expiration time found');
      return false;
    }

    const isValid = new Date().getTime() < parseInt(expirationTime);
    // console.log('Token validation:', { isValid, expirationTime });
    return isValid;
  } catch (error) {
    console.error('Auth validation error:', error);
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('expirationTime');
};
